module.exports = __webpack_public_path__ + "static/media/searchLocation.1ea44023.svg";